import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ColumnDef, LocalTimePoint, TableSorting, Pager } from "shared-lib";
import { Router } from "@angular/router";
import { WebhookEventTypesDto } from "@merchant_api/models/webhook-event-types-dto";
import { EventOrderByEnum } from "@merchant_api/models/event-order-by-enum";
import { Filter, Sorting } from "@merchant_app/storage/events/events.state";
import { EventsDto } from "@merchant_api/models/events-dto";

@Component({
    selector: "app-event-history-log",
    templateUrl: "./event-history-log.component.html",
    styleUrls: ["./event-history-log.component.less"],
    standalone: false
})
export class EventHistoryLogComponent {

    @Input() events: Array<EventsDto>;
    @Input() loading = false;
    @Input() error: Error;
    @Input() webhookLookups: WebhookEventTypesDto;

    @Input() sorting: Sorting = {
        orderBy: null,
        orderDirection: null
    };
    @Input() pager: Pager;
    @Input() filter: Filter;

    @Output() sortingChanged = new EventEmitter<Sorting>();
    @Output() pageChanged = new EventEmitter<number>();
    @Output() filterChanged = new EventEmitter<Filter>();

    // NOTE: Optimise table widths against minimum table width (or table can have bottom horizontal scrollbar)
    eventsColumnDefs: ColumnDef[] = [
        { id: "leftGutter", title: "", flexWidthBasisInPixels: 20, flexWidthGrow: 0},
        { id: EventOrderByEnum.Id, title: "ID", flexWidthBasisInPixels: 150, flexWidthGrow: 0, canSort: true},
        { id: "token", title: "Token", flexWidthBasisInPixels: 340, flexWidthGrow: 0},
        { id: EventOrderByEnum.EventType, title: "Event Type", flexWidthBasisInPixels: 440, flexWidthGrow: 0, canSort: true},
        { id: EventOrderByEnum.CreatedUtc, title:`Date (${LocalTimePoint.formatZ()})`,
            flexWidthBasisInPixels: 140, flexWidthGrow: 0, canSort: true},
        { id: "rightGutter", title: "", flexWidthBasisInPixels: 20, flexWidthGrow: 0},
    ];

    constructor(private router: Router) {}

    onSortingChanged(sorting: TableSorting) {
        this.sortingChanged.emit({
            orderBy: sorting.orderBy as EventOrderByEnum,
            orderDirection: sorting.orderDirection
        });
    }

    onRowSelected(token: string) {
        this.router.navigate([`/dashboard/developer/webhooks/event-history/${token}`]);
    }

}
